import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Dashboard as DashboardIcon,
    Assignment as AssignmentIcon,
    AssignmentReturn as AssignmentReturnIcon,
    FormatListBulletedOutlined as ListOutlinedIcon,
} from '@material-ui/icons';
import { Title as SidebarTitle, Content as SidebarContent } from '../SidebarMenu';

import ActionIconButton from '../ActionIconButton';

/**
 * @param {{
 *  title: string; onIconTitleClick?: Function;
 * }} param0 */
const SidebarManager = ({
    title,
    onIconTitleClick,
}) => {
    const { t } = useTranslation('menu');
    const onClickMenu = () => { };

    return (
        <div className="core--sidebar-menu">
            <SidebarTitle
                title={title}
                icon={<ListOutlinedIcon />}
                onIconTitleClick={onIconTitleClick}
            />
            <SidebarContent>
                <ActionIconButton
                    className="menu-item active"
                    onClick={onClickMenu}
                >
                    <>
                        <DashboardIcon />
                        <label>{t('manager.mainDashboard')}</label>
                    </>
                </ActionIconButton>
                <ActionIconButton
                    className="menu-item"
                    onClick={onClickMenu}
                >
                    <>
                        <AssignmentIcon />
                        <label>{t('manager.audits')}</label>
                    </>
                </ActionIconButton>
                <ActionIconButton
                    className="menu-item"
                    onClick={onClickMenu}
                >
                    <>
                        <AssignmentReturnIcon />
                        <label>{t('manager.archives')}</label>
                    </>
                </ActionIconButton>
            </SidebarContent>
        </div>
    );
};

export default SidebarManager;
